<template>
  <ObjectsNav
    nav-context="connections"
    :show-add-button="true"
    :show-settings="true"
  />
</template>

<script>
import ObjectsNav from '@/components/objects/ObjectsNav';

export default {
  components: {
    ObjectsNav,
  },
};
</script>
